<script setup>
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import NucleoWorkOrderHistory from './NucleoWorkOrderHistory.vue';
import NucleoWorkOrderNotes from './NucleoWorkOrderNotes.vue';
import NucleoWorkOrderPaymentDocuments from './NucleoWorkOrderPaymentDocuments.vue';
import NucleoWorkOrderRequestDocuments from './NucleoWorkOrderRequestDocuments.vue';
import SalesDetailNucleoRequestSummary from './SalesDetailNucleoRequestSummary.vue';
import SalesDetailNucleoServices from './SalesDetailNucleoServices.vue';

const props = defineProps({
  request: { type: Object, required: true },
  showOpenAction: { type: Boolean, default: true },
});
const { t } = useI18n();
const route = useRoute();
const selectedServiceId = ref(null);
const requestDate = computed(() =>
  props.request.data_criacao
    ? new Intl.DateTimeFormat('pt-BR').format(
        new Date(props.request.data_criacao)
      )
    : t('SALES.DETAIL.EMPTY_VALUE')
);
const selectedService = computed(() =>
  props.request.servicos?.find(
    service => String(service.id) === String(selectedServiceId.value)
  )
);

watch(
  () => props.request.id,
  () => {
    selectedServiceId.value = props.request.servicos?.[0]?.id || null;
  },
  { immediate: true }
);
</script>

<template>
  <section class="grid gap-4">
    <header
      data-test="nucleo-request-header"
      class="flex flex-wrap items-center justify-between gap-3"
    >
      <h3 data-test="nucleo-request-date" class="font-semibold text-lais-text">
        {{ requestDate }}
      </h3>
      <div v-if="showOpenAction" class="flex flex-wrap items-center gap-3">
        <p class="text-sm text-lais-text-body">
          {{ t('SALES.DETAIL.NUCLEO.PROGRESS', request.progresso || {}) }}
        </p>
        <RouterLink
          v-if="showOpenAction"
          :to="{
            name: 'operacao_imobiliaria_nucleo_detalhe',
            params: {
              accountId: route.params.accountId,
              imovelListingId: request.imovel_listing_id,
              workOrderId: request.id,
            },
          }"
          class="text-sm font-semibold text-lais-link hover:text-lais-link-hover"
        >
          {{ t('SALES.DETAIL.NUCLEO.OPEN') }}
        </RouterLink>
      </div>
    </header>
    <SalesDetailNucleoServices
      :services="request.servicos || []"
      :selected-service-id="selectedServiceId"
      @select="selectedServiceId = $event"
    />
    <SalesDetailNucleoRequestSummary :request="request" />
    <NucleoWorkOrderRequestDocuments
      :documents="request.request_documents || []"
      :title="t('SALES.DETAIL.NUCLEO.DOCUMENTS_TITLE')"
      :transaction-id="request.documentos?.property_transaction_id"
    />
    <NucleoWorkOrderHistory :service="selectedService" />
    <NucleoWorkOrderPaymentDocuments :request="request" />
    <NucleoWorkOrderNotes :services="request.servicos || []" />
  </section>
</template>
